import { withRouter } from 'react-router';

import EmbedBlock from './EmbedBlock';

export default withRouter(EmbedBlock);
